import * as React from 'react';

function SvgCounterOfferTutorial(props) {
  return (
    <svg width={208} height={121} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#counter-offer-tutorial_svg__clip0_1758_68939)">
        <rect y={0.002} width={208} height={120} rx={2} fill="#ABD9D0" />
        <path
          d="M208 10.713H0v.44h208v-.44zM208 26.934H0v.44h208v-.44zM208 43.158H0v.44h208v-.44zM208 59.378H0v.44h208v-.44zM208 75.6H0v.44h208v-.44zM208 91.82H0v.44h208v-.44zM208 108.041H0v.44h208v-.44z"
          fill="#38B2A6"
          opacity={0.25}
        />
        <path
          d="M181.289-118.588h-.441v347.176h.441v-347.176zM165.064-118.588h-.44v347.176h.44v-347.176zM197.456-118.588h-.44v347.176h.44v-347.176zM148.837-118.588h-.441v347.176h.441v-347.176zM132.612-118.588h-.44v347.176h.44v-347.176zM116.388-118.588h-.441v347.176h.441v-347.176zM100.163-118.588h-.44v347.176h.44v-347.176zM83.939-118.588h-.44v347.176h.44v-347.176zM67.714-118.588h-.44v347.176h.44v-347.176zM51.487-118.588h-.44v347.176h.44v-347.176zM35.263-118.588h-.441v347.176h.44v-347.176zM19.038-118.588h-.44v347.176h.44v-347.176z"
          fill="#38B2A6"
          opacity={0.25}
        />
        <path
          d="M54.057 111.163v-10.044h61.882v10.044H54.057z"
          fill="#81CCBF"
          stroke="#EBF2FF"
          strokeWidth={0.114}
        />
        <path
          d="M56.303 106.141h4.984M57.549 108.298l2.492-4.315M60.041 108.298l-2.492-4.315M63.404 106.141h4.983M64.65 108.298l2.491-4.315M67.141 108.298l-2.492-4.315M70.505 106.141h4.982M71.75 108.298l2.492-4.315M74.242 108.298l-2.492-4.315M77.606 106.141h4.983M78.852 108.298l2.492-4.315M81.344 108.298l-2.492-4.315M84.707 106.141h4.983M85.952 108.298l2.492-4.315M88.444 108.298l-2.492-4.315"
          stroke="#EBF2FF"
          strokeWidth={0.975}
        />
        <path
          d="M54.057 97.503V87.459h61.882v10.044H54.057z"
          fill="#81CCBF"
          stroke="#EBF2FF"
          strokeWidth={0.114}
        />
        <path d="M57.333 92.83h38.393" stroke="#EBF2FF" strokeWidth={0.975} />
        <path
          d="M118.75 44.658a2.07 2.07 0 002.07 2.07h1.378v4.828l4.828-4.828h15.865a2.07 2.07 0 002.069-2.07V27.414a2.07 2.07 0 00-2.069-2.07H120.82a2.07 2.07 0 00-2.07 2.07v17.244z"
          fill="#F9A600"
        />
        <path
          d="M140.822 31.553h-17.934v1.38h17.934v-1.38zM140.822 35.002h-17.934v1.38h17.934v-1.38zM140.822 38.45h-17.934v1.38h17.934v-1.38zM153.75 66.024c0 .973-.789 1.763-1.763 1.763h-15.275c-.972 0-1.763-.79-1.763-1.763V43.7c0-.973.79-1.763 1.763-1.763h10.576l6.462 6.462v17.625z"
          fill="#fff"
        />
        <path d="M147.874 47.812l5.876 5.797V48.4l-.587-.587h-5.289z" fill="#C2D7FF" />
        <path
          d="M147.287 41.937v4.7c0 .973.789 1.763 1.761 1.763h4.701l-6.462-6.463z"
          fill="#506FCC"
        />
        <path
          d="M150.224 56.037h-11.75v1.175h11.75v-1.175zM150.224 58.387h-11.75v1.175h11.75v-1.175zM150.224 60.736h-11.75v1.175h11.75v-1.175zM147.287 53.687h-8.813v1.176h8.813v-1.176z"
          fill="#6B92F3"
        />
        <path
          d="M117.256 24.55c0 .607-.457 1.098-1.023 1.098h-1.983v4.116l-4.859-4.116h-9.97c-.566 0-1.026-.49-1.026-1.098V12.098c0-.607.459-1.097 1.026-1.097h16.813c.566 0 1.023.49 1.023 1.097v12.454h-.001z"
          fill="#FF4D4F"
        />
        <path
          d="M111.345 18.266l-2.752 1.588-2.752 1.589v-6.354l2.752 1.588 2.752 1.589z"
          fill="#fff"
        />
        <path d="M37.625 31.002L36 32.627l6.374 6.375L44 37.376l-6.375-6.374z" fill="#FFD15A" />
        <path d="M42.374 30.998L36 37.373l1.625 1.626L44 32.623l-1.626-1.626z" fill="#FFD15A" />
        <path d="M190.943 69.353l-2.22.595 2.333 8.708 2.22-.595-2.333-8.708z" fill="#FFCCC7" />
        <path d="M195.058 71.725l-8.708 2.334.595 2.22 8.708-2.333-.595-2.22z" fill="#FFCCC7" />
        <path d="M111.004 62.752v12.76l-11.06-11.058 11.06-1.702z" fill="#81CCBF" />
        <path
          d="M66.82 68.39c0 .906.735 1.639 1.64 1.639h45.253c.907 0 1.639-.733 1.639-1.639V36.713c0-.905-.733-1.637-1.639-1.637H68.461c-.906 0-1.64.733-1.64 1.637V68.39z"
          fill="#81CCBF"
        />
        <path
          d="M76.029 40.419a2.497 2.497 0 11-4.995 0 2.497 2.497 0 014.995 0zM103.961 41.122H78.213v1.092h25.748v-1.092zM92.725 38.625H78.213v1.092h14.512v-1.092z"
          fill="#fff"
        />
        <path d="M111.451 45.378h-40.28v20.58h40.28v-20.58z" fill="#38B2A6" />
        <path d="M93.322 55.668l-2.527 1.46-2.53 1.46v-5.839l2.53 1.459 2.527 1.46z" fill="#fff" />
        <path d="M22.529 77h-3.06v12h3.06V77z" fill="#FFDF28" />
        <path d="M27 81.468H15v3.06h12v-3.06z" fill="#FFDF28" />
        <path d="M138.764 99h-1.53v6h1.53v-6z" fill="#FAFAFA" />
        <path d="M141 101.233h-6v1.531h6v-1.531z" fill="#FAFAFA" />
        <mask id="counter-offer-tutorial_svg__a" fill="#fff">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M173.468 14h3.061v4.468H181v3.06h-4.471V26h-3.061v-4.471H169v-3.06h4.468V14z"
          />
        </mask>
        <path
          d="M176.529 14h.6v-.6h-.6v.6zm-3.061 0v-.6h-.6v.6h.6zm3.061 4.468h-.6v.6h.6v-.6zm4.471 0h.6v-.6h-.6v.6zm0 3.06v.6h.6v-.6h-.6zm-4.471 0v-.6h-.6v.6h.6zm0 4.472v.6h.6V26h-.6zm-3.061 0h-.6v.6h.6V26zm0-4.471h.6v-.6h-.6v.6zm-4.468 0h-.6v.6h.6v-.6zm0-3.06v-.6h-.6v.6h.6zm4.468 0v.6h.6v-.6h-.6zm3.061-5.069h-3.061v1.2h3.061v-1.2zm.6 5.068V14h-1.2v4.468h1.2zm3.871-.6h-4.471v1.2H181v-1.2zm.6 3.66v-3.06h-1.2v3.06h1.2zm-5.071.6H181v-1.2h-4.471v1.2zm.6 3.872v-4.471h-1.2V26h1.2zm-3.661.6h3.061v-1.2h-3.061v1.2zm-.6-5.071V26h1.2v-4.471h-1.2zm-3.868.6h4.468v-1.2H169v1.2zm-.6-3.66v3.06h1.2v-3.06h-1.2zm5.068-.6H169v1.2h4.468v-1.2zm-.6-3.869v4.468h1.2V14h-1.2z"
          fill="#E9F7EC"
          mask="url(#counter-offer-tutorial_svg__a)"
        />
      </g>
      <defs>
        <clipPath id="counter-offer-tutorial_svg__clip0_1758_68939">
          <rect y={0.002} width={208} height={120} rx={2} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCounterOfferTutorial;
